import React from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';

type TopicChipVariant = 'topic' | 'issue';

const CHIP_COLOURS: Record<TopicChipVariant, string> = {
  topic: '#059a8f',
  issue: '#a8546b'
};

type SingleTopicChipProps = {
  tag: string;
  isMoreTag?: boolean;
  variant?: TopicChipVariant;
  setHideExtraTags: React.Dispatch<React.SetStateAction<boolean>>;
};

const CHIP_CLASSES =
  'm-0.5 inline-block max-w-[10rem] truncate rounded-full px-3 py-1 ' +
  'text-[0.8125rem] leading-normal text-white max-[600px]:text-[0.75rem]';

function SingleTopicChip({
  tag,
  isMoreTag = false,
  variant = 'topic',
  setHideExtraTags
}: SingleTopicChipProps): React.ReactElement {
  const isTablet = useMediaQuery('(max-width: 767.98px)');

  if (isMoreTag && isTablet) {
    return (
      <span className='text-brand-grey m-1 text-[0.75rem]'>{`+ ${tag}`}</span>
    );
  }

  const isExpandable = isMoreTag && !isTablet;

  if (isExpandable) {
    return (
      <button
        type='button'
        aria-label='Show other tags'
        style={{ backgroundColor: CHIP_COLOURS[variant] }}
        className={`${CHIP_CLASSES} cursor-pointer border-0`}
        onClick={(ev) => {
          ev.stopPropagation();
          setHideExtraTags(false);
        }}
      >
        {tag}
      </button>
    );
  }

  return (
    <span
      style={{ backgroundColor: CHIP_COLOURS[variant] }}
      className={CHIP_CLASSES}
    >
      {tag}
    </span>
  );
}

export default SingleTopicChip;
